import { ChangePasswordForm } from '@/components/ChangePasswordForm'
import { useT } from '@/contexts/language'

/**
 * Admin account page. Exists mainly so the seeded password from migration 004 can be
 * changed from the UI — it is public in the repository and also authorises payout
 * edits, so leaving it in place is the single biggest hole in a fresh deployment.
 */
export default function AdminProfilePage() {
  const t = useT()
  return (
    <div className="p-4 md:p-6 max-w-2xl">
      <div className="mb-5">
        <span className="font-mono text-xs font-bold uppercase tracking-wider text-foreground">
          {t.nav.profile}
        </span>
      </div>
      <ChangePasswordForm />
    </div>
  )
}
